import { klausPromoAllowed } from '@app/constants/klaus';
import { useUserWithCompany } from './useUserWithCompany';

/**
 * Single gate for every Klaus cross-promo touchpoint rendered from a component. See
 * `klausPromoAllowed` for what is being decided; the message-queue condition in `MessageContext`
 * cannot call hooks and uses that helper directly instead.
 *
 * `resolving` is for callers that decide once and cannot revise later — they have to wait for it
 * to clear rather than read `allowed`, which is `false` for as long as the answer is unknown.
 */
export function useKlausPromoAllowed(): { allowed: boolean; resolving: boolean } {
  const { user, whitelabelConfig, whitelabelLoading } = useUserWithCompany();
  return {
    allowed: klausPromoAllowed({
      whitelabelConfig,
      whitelabelLoading,
      hasWhitelabelFeature: user?.hasFeature('Whitelabel'),
    }),
    resolving: whitelabelLoading,
  };
}
